import { Fragment, useRef, useState } from "react";
import clsx from "clsx";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ErrorText } from "components/atoms/ErrorText";
import { AffiliateModal } from "components/organism/Modals/AffiliateModal";
import { useNavigate } from "react-router-dom";

const Forms = () => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const childRef = useRef(null);

    const navigate = useNavigate();

    const initialValues = {
        firstname: "",
        lastname: "",
        email: "",
        domainname: "",
        about: ""
    };

    const disabledFn = () => {
        if (firstname && lastname && email && domainname && about) return false;
        return true;
    };

    const schemaValidations = Yup.object({
        firstname: Yup.string()
            .min(3, "Minimum 3 character")
            .required("Field First Name Required"),
        lastname: Yup.string()
            .min(3, "Minimum 3 character")
            .required("Field Last Name Required"),
        domainname: Yup.string(),
        email: Yup.string()
            .email("Invalid Email Address")
            .required("Field Email Required"),
        about: Yup.string()
            .min(20, "Minimum 20 character length")
            .required("Field Message Required")
    });

    const ApplyAsAffiliateHandler = async (values) => {
        setLoading(true);
        try {
            const message = "Thank you! Your submission has been received!";

            setOpen(true);
            console.log(values);

            setTimeout(() => {
                childRef.current.openModal();
                // toast.success(message);
                setLoading(false);
            }, 3000);

            setTimeout(() => {
                navigate("/auth/signin");
            }, 7000);
        } catch (error) {
            console.log(error);
            setLoading(false);

            toast.error("Send Message Failed");
        }
    };
    return (
        <Fragment>
            <header className={clsx(
                "w-full",
                "bg-primary-main"
            )}>
                <AffiliateModal childRef={childRef} />
                <div className={clsx(
                    "max-w-[1440px] mx-auto relative",
                    "flex flex-col md:flex-row justify-between",
                    "pt-[96px] pb-[84px] tablet:py-16 phone:py-12 px-6 overflow-hidden tablet:px-8 desktop:px-[120px]"
                )}>
                    <img src="/images/affiliates/forms/brick-lg.svg" className="w-[184px] h-[187px] tablet:w-[140px] tablet:h-[142px] absolute left-[120px] tablet:left-[32px] bottom-[220px] tablet:bottom-[230px] desktop:bottom-[230px]" alt="brick" />
                    <img src="/images/affiliates/forms/brick-sm.svg" className="w-[103px] h-[114px] absolute left-[354px] bottom-[509px] tablet:bottom-[436px] tablet:left-[345px] desktop:bottom-[458px] desktop:left-[446px]" alt="brick" />
                    <div className="w-full md:max-w-[440px]">
                        <h1 className="text-heading-1 phone:text-heading-3 tablet:text-heading-3 tablet:leading-[54px] desktop:text-display font-semibold text-basier-circle-semibold text-neutral-10">Let's Be Partners!</h1>
                        <p className="text-neutral-10 tablet:max-w-[364px] font-normal tablet:text-md desktop:text-md phone:text-md text-md tracking-text leading-[27.2px] pt-4">
                            If you want to become an affiliate please fill out this attached form. Someone from our staff will get back to you with more details on how to get started.
                        </p>
                    </div>
                    <div className="w-full mt-10 md:mt-0 rounded-lg bg-neutral-10 max-w-[687px] phone:p-4 tablet:p-6 p-8">
                        <Formik initialValues={initialValues} validationSchema={schemaValidations} onSubmit={ApplyAsAffiliateHandler}>
                            {({ errors, touched }) => (
                                <Form>
                                    <div className="w-full flex flex-col md:flex-row justify-between space-y-6 md:space-y-0 md:space-x-6 mb-6 tablet:mb-5 phone:mb-5">
                                        <div className="w-full">
                                            <h3 className="font-normal phone:tracking-[0px] phone:text-sm text-md text-neutral-50 tracking-text pb-4 phone:leading-[17.43px] leading-[19.92px]">First Name</h3>
                                            <Field type="text" name="firstname" className={clsx(
                                                "w-full border-none h-[56px] px-4 bg-neutral-20 rounded-lg",
                                                errors.firstname && touched.firstname ? "border border-red-600 !bg-neutral-10" : ""
                                            )} />
                                            <ErrorMessage name="firstname" component={ErrorText} />
                                        </div>
                                        <div className="w-full">
                                            <h3 className="font-normal phone:tracking-[0px] phone:text-sm text-md text-neutral-50 tracking-text pb-4 phone:leading-[17.43px] leading-[19.92px]">Last Name</h3>
                                            <Field type="text" name="lastname" className={clsx(
                                                "w-full border-none h-[56px] px-4 bg-neutral-20 rounded-lg",
                                                errors.lastname && touched.lastname ? "border border-red-600 !bg-neutral-10" : ""
                                            )} />
                                            <ErrorMessage name="lastname" component={ErrorText} />
                                        </div>
                                    </div>
                                    <div className="w-full mb-6 tablet:mb-5 phone:mb-6">
                                        <h3 className="font-normal phone:tracking-[0px] phone:text-sm text-md text-neutral-50 tracking-text pb-4 phone:leading-[17.43px] leading-[19.92px]">Email Address</h3>
                                        <Field type="text" name="email" className={clsx(
                                            "w-full border-none h-[56px] px-4 bg-neutral-20 rounded-lg",
                                            errors.email && touched.email ? "border border-red-600 !bg-neutral-10" : ""
                                        )} />
                                        <ErrorMessage name="email" component={ErrorText} />
                                    </div>
                                    <div className="w-full mb-6 tablet:mb-5 phone:mb-6">
                                        <h3 className="font-normal phone:tracking-[0px] phone:text-sm text-md text-neutral-50 tracking-text pb-4 phone:leading-[17.43px] leading-[19.92px]">Domain Name (if any)</h3>
                                        <Field type="text" name="domainname" className={clsx(
                                            "w-full border-none h-[56px] px-4 bg-neutral-20 rounded-lg",
                                            errors.domainname && touched.domainname ? "border border-red-600 !bg-neutral-10" : ""
                                        )} />
                                        <ErrorMessage name="domainname" component={ErrorText} />
                                    </div>
                                    <div className="w-full mb-8 desktop:mb-8 tablet:mb-8">
                                        <h3 className="font-normal phone:tracking-[0px] phone:text-sm text-md text-neutral-50 mt-6 mb-4 tablet:mt-5 tracking-text phone:leading-[17.43px] leading-[19.92px]">Tell us a little about yourself and your plan</h3>
                                        <Field type="text" name="about" id="message" rows="100" cols="50" className={clsx(
                                            "w-full border-none phone:h-[150px] tablet:h-[150px] h-[200px] p-4 bg-neutral-20 rounded-lg resize-none",
                                            errors.about && touched.about ? "border border-red-600 !bg-neutral-10" : ""
                                        )} />
                                        <ErrorMessage name="about" component={ErrorText} />
                                    </div>
                                    <button disabled={disabledFn} className={clsx(
                                        "w-full py-[18px] text-neutral-10 font-semibold text-md leading-[19.83px] h-[56px] flex items-center justify-center rounded-lg tracking-text bg-primary-main hover:bg-primary-hover"
                                    )}>{loading ? "Loading..." : "Apply as an Affiliate"}</button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};

export default Forms;